import { render, staticRenderFns } from "./ApproveSpendData.vue?vue&type=template&id=ac184812&"
import script from "./ApproveSpendData.vue?vue&type=script&lang=js&"
export * from "./ApproveSpendData.vue?vue&type=script&lang=js&"
import style0 from "./ApproveSpendData.vue?vue&type=style&index=0&id=ac184812&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports